import { ConstructPost } from '../../../types/ConstructPost';
import { MIDDLE_OFFICE_BASE_PATH } from '../../constants/middleOfficeBasePath';

export const postResetBrokerTwoFactor = (
  constructPost: ConstructPost,
  userId: string,
): Promise<unknown> =>
  constructPost(
    `${MIDDLE_OFFICE_BASE_PATH}/brokers/${userId}/reset-two-factor`,
    undefined,
    { preventDefaultErrorToast: true },
  );
